import CampaignLeadsCard from './CampaignLeadsCard'
import ConversionCard from './ConversionCard'
import OrdersClosedCard from './OrdersClosedCard'
import OrdersLostCard from './OrdersLostCard'
import TargetAchievementCard from './TargetAchievementCard'

export default function DashboardStats({
  campaignLeads,
  conversionNumbers,
  ordersClosed,
  ordersLost,
  target,
  achievement,
  ordersClosedBySalesperson,
  period,
  customRange,
}) {
  return (
    <section className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
      <CampaignLeadsCard
        data={campaignLeads}
        period={period}
        customRange={customRange}
      />
      <ConversionCard
        data={conversionNumbers}
        period={period}
        customRange={customRange}
      />
      <TargetAchievementCard
        target={target}
        achievement={achievement ?? ordersClosed?.total ?? 0}
        achievementRevenue={ordersClosed?.revenue ?? 0}
        salespersonData={ordersClosedBySalesperson}
        isTeam={true}
        period={period}
        customRange={customRange}
      />
      <OrdersClosedCard
        data={ordersClosed}
        period={period}
        customRange={customRange}
      />
      <OrdersLostCard
        data={ordersLost}
        period={period}
        customRange={customRange}
      />
    </section>
  )
}
